import { useCallback, useEffect, useRef, useState } from 'react';

export function useSleepTimer(stopPlayback) {
  const [sleepMinutes, setSleepMinutes] = useState(null);
  const [remainingSeconds, setRemainingSeconds] = useState(0);
  const intervalRef = useRef(null);
  const secondsRef = useRef(0);

  const startTimer = useCallback((minutes) => {
    clearInterval(intervalRef.current);
    secondsRef.current = minutes * 60;
    setSleepMinutes(minutes);
    setRemainingSeconds(minutes * 60);
  }, []);

  const cancelTimer = useCallback(() => {
    clearInterval(intervalRef.current);
    setSleepMinutes(null);
    setRemainingSeconds(0);
  }, []);

  useEffect(() => {
    if (sleepMinutes === null) {
      clearInterval(intervalRef.current);
      return;
    }

    intervalRef.current = setInterval(() => {
      secondsRef.current -= 1;
      setRemainingSeconds(secondsRef.current);
      if (secondsRef.current <= 0) {
        clearInterval(intervalRef.current);
        setSleepMinutes(null);
        stopPlayback();
      }
    }, 1000);

    return () => clearInterval(intervalRef.current);
  }, [sleepMinutes, stopPlayback]);

  return { sleepMinutes, remainingSeconds, startTimer, cancelTimer };
}

export function formatSleepTime(seconds) {
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  return `${m}:${String(s).padStart(2, '0')}`;
}
